import React, { useState } from 'react'

// Utils
import noop from 'utils/noop'

// Constants
import { SKETCH_WEBSITE } from 'constants/sketchWebsite'

// Components
import Modal from 'components/Modal'
import Button from 'components/Button'
import { Text } from 'components/Box'
import Checkbox from 'components/Checkbox'

// Types
import { useAgreeToWorkspaceCustomerTermsOfServiceMutation } from 'gqlTypes'

interface TosMandatoryModalProps {
  workspaceId: string
  customerId: string
}

const TosMandatoryModal: React.FC<TosMandatoryModalProps> = ({
  workspaceId,
  customerId,
}) => {
  const [hasAcceptedTos, setTos] = useState(false)

  const [
    agreeToTos,
    { loading },
  ] = useAgreeToWorkspaceCustomerTermsOfServiceMutation({
    variables: {
      customerId,
      tosAgreed: hasAcceptedTos,
    },
    onError: 'show-toast',
  })

  const handleOnClick = () => agreeToTos({})

  return (
    <Modal onCancel={noop}>
      <Modal.Header>Terms of Service</Modal.Header>
      <Modal.Body>
        <Text>
          In order to access your workspace, please accept the Terms of Service.
          <br />
          If you have any questions, please email{' '}
          <a href="mailto:licensing@sketch.com">licensing@sketch.com</a>.
        </Text>
        <label className="sr-only" htmlFor="tos-check">
          I accept the terms of service.
        </label>
        <Checkbox
          id="tos-check"
          checked={hasAcceptedTos}
          onClick={() => setTos(!hasAcceptedTos)}>
          I accept the{' '}
          <a
            target="_blank"
            href={`${SKETCH_WEBSITE}/tos`}
            rel="noopener noreferrer">
            Terms of Service.
          </a>
        </Checkbox>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          disabled={!hasAcceptedTos}
          loading={loading}
          onClick={handleOnClick}>
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default TosMandatoryModal
